// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"0ba67204","29":"e96d3df7","201":"8d4526f5","418":"c7516c6a","453":"f51b6e2f","569":"69615eb1","579":"032a71cd","813":"0aef8232","934":"af7036ae"}[chunkId] + ".chunk.js";
};